import type { ReactNode } from 'react';

import { cn } from '@nesso/ui/lib/utils';

type Props = {
    title?: string;
    label?: ReactNode;
    children: ReactNode;
    className?: string;
};

export function FieldSection({ title, label, children, className }: Props) {
    return (
        <div className={cn('flex flex-col gap-3', className)}>
            {title && <h3 className="text-xl font-bold leading-none">{title}</h3>}
            {label && <p className="text-base">{label}</p>}
            {children}
        </div>
    );
}
